import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { HintText } from "./styles";
import PromoCodeInput from "./PromoCodeInput";

type PromoCodeType = {
  setDiscount: (number: number) => void;
  classPrice: number;
  currency: string;
};

const PromoCode = ({ setDiscount, classPrice, currency }: PromoCodeType) => {
  const { t } = useTranslation("registration");
  const [inputVisible, setInputVisible] = useState<boolean>(true);
  const [status, setStatus] = useState(0);
  const havePromoCode = () => setStatus(1);
  // HANDLERS
  const hideInput = () => setInputVisible(false);
  const showInput = () => setInputVisible(true);
  return (
    <div style={{ textAlign: "left", marginBottom: 0, marginTop: 20 }}>
      {status === 0 ? (
        <HintText onClick={havePromoCode}>
          {t("Have a discount code?")}
        </HintText>
      ) : (
        <PromoCodeInput
          inputVisible={inputVisible}
          hideInput={hideInput}
          showInput={showInput}
          setDiscount={setDiscount}
          classPrice={classPrice}
          currency={currency}
        />
      )}
    </div>
  );
};

export default PromoCode;
